<template>
  <div>
    <div class="text-xs w-full">
      <HeroTableFilter
        @getPageSize="HandlerData"
        @getSearch="HandlerSearch"
        @getSortByDescription="HandlerSortDescription"
        @getSortBy="HandlerSort"
        @selectedFilter="HandlerFilter"
        :itemApprovalCount="approvalTypeCountList"
        :selectedTab="selectedFilterStatus"
      />
      <table class="w-full border-collapse">
        <thead>
          <tr class="bg-gray-100 font-bold">
            <th class="border-y border-gray-300 px-2 py-2 text-left">
              Member Name
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-left">
              Transaction ID
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-left">
              Provider Name
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Date of Admission
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Date of Received
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              # of Days to Comply
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Status
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in updatedDataArray"
            :key="item.id"
            class="odd:bg-white even:bg-gray-50 hover:bg-gray-100 transition"
          >
            <td class="border-y border-gray-300 px-2 py-2">
              <div class="flex items-center gap-4">
                <div class="flex flex-col min-w-52">
                  <span class="font-semibold">{{ item.membername }}</span>
                  <span class="text-gray-600">{{ item.company }}</span>
                </div>
              </div>
            </td>
            <td class="border-y border-gray-300 px-2 py-2 min-w-48 select-all">
              {{ item.transactionnumber }}
            </td>
            <td class="border-y border-gray-300 px-2 py-2">
              {{ item.providername }}
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-center">
              {{ item.admitdate }}
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-center">
              {{ item.requestdate ? item.requestdate : "-" }}
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-right">
              <span
                :class="[
                  'inline-block px-2 py-1 text-xs ',
                  renderCompileDay(item) < 5
                    ? 'bg-red-100 text-red-600 rounded-full'
                    : ' text-gray-700',
                ]"
              >
                {{ renderCompileDay(item) }}
              </span>
            </td>

            <td class="border-y border-gray-300 px-2 py-2 min-w-48 text-center">
              <span
                class="inline-block px-3 py-1 rounded-full text-xs font-medium"
                :class="{
                  'bg-green-100 text-green-800':
                    item.approvaltype === 'Approved',
                  'bg-red-100 text-red-800': item.approvaltype === 'Declined',
                  'bg-blue-100 text-blue-800':
                    item.approvaltype === 'Assessment',
                  'bg-yellow-100 text-yellow-800':
                    item.approvaltype === 'Pending Documents',
                }"
              >
                {{ item.approvaltype }}
              </span>
            </td>
            <td class="border-y border-gray-300 px-2 py-2">
              <div class="flex gap-2">
                <icon-view
                  @click="viewHandler(item)"
                  class="text-blue-600 hover:underline text-xs cursor-pointer"
                >
                  View
                </icon-view>
                <icon-edit
                  @click="editHandler(item)"
                  class="text-yellow-600 hover:underline text-xs cursor-pointer"
                >
                  Edit
                </icon-edit>
                <icon-link
                  v-if="true"
                  @click="$router.push(`/tracking/${item.transactionnumber}`)"
                  class="text-yellow-600 hover:underline text-xs cursor-pointer"
                >
                  link
                </icon-link>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <PaginationGrid
        :totalPages="totalPages"
        :currentPage="currentPage"
        @update:currentPage="handlePageChange"
      />
    </div>
  </div>

  <DataDetails
    :itemDataDetails="renderDataDetails"
    :isModalTriggired="isTriggiered"
    @close="isTriggiered = false"
  />
</template>

<script>
import HeroTableFilter from "@/components/common/HeroTableFilter.vue";
import PaginationGrid from "@/components/common/HeroPagination.vue";
import DataDetails from "@/components/partial/Application/SectionDetailView.vue";
import IconEdit from "@/components/svg/EditSVG.vue";
import IconView from "@/components/svg/ViewSVG.vue";
import IconLink from "@/components/svg/LinkSVG.vue";
import { ref, onMounted, toRefs, inject, watch, computed } from "vue";
import UsedPaginationUtils from "@/utils/reusables/pagination";
import { useRoute } from "vue-router";

export default {
  components: {
    HeroTableFilter,
    PaginationGrid,
    DataDetails,
    IconEdit,
    IconView,
    IconLink,
  },
  props: {
    actionButton: Boolean,
    isReload: Boolean,
  },
  emits: ["actionHandler"],
  setup(props, { emit }) {
    const { paginationItem, totalPages, filterLimit } = UsedPaginationUtils();
    const route = useRoute();
    const axios = inject("$axios");
    const moment = inject("$moment");
    const selectedPageSize = ref(0);
    const searchData = ref();
    const updatedDataArray = ref([]);
    const renderDataDetails = ref([]);
    const renderDataUpdate = ref([]);
    const isTriggiered = ref(false);
    const isModalUpdate = ref(false);
    const selectedFilterStatus = ref("All");
    const approvalTypeCountList = ref({});
    const sortByDescription = ref();
    const sortBy = ref();

    onMounted(() => {
      selectedFilterStatus.value = route.query.status;
      fetchData();
    });

    const fetchData = async () => {
      try {
        const { data } = await axios.get(`/portal/application/reimbursement`, {
          params: {
            search: searchData.value,
            approvaltype:
              selectedFilterStatus.value === "All"
                ? ""
                : selectedFilterStatus.value,
            pageSize: paginationItem.PageSize,
            page: paginationItem.currentPage - 1,
            sortByDescription: sortByDescription.value,
            sortBy: sortBy.value,
          },
        });
        updatedDataArray.value = data;
        fetchDataCount();
        fetchGroupApprovalDataCount();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataCount = async () => {
      try {
        const { data } = await axios.get(
          `portal/application/reimbursement/count`,
          {
            params: {
              search: searchData.value,
              approvaltype:
                selectedFilterStatus.value === "All"
                  ? ""
                  : selectedFilterStatus.value,
            },
          }
        );
        paginationItem.totalItems = data.total;
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };
    const fetchGroupApprovalDataCount = async () => {
      try {
        const { data } = await axios.get(
          `portal/application/reimbursement/approvaltype/count`
        );
        approvalTypeCountList.value = data;
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };
    const HandlerData = (val) => {
      selectedPageSize.value = val;
      paginationItem.PageSize = val;
    };
    const HandlerSearch = (val) => {
      searchData.value = val;
    };

    watch(() => selectedPageSize.value, fetchData);
    watch(() => searchData.value, fetchData);
    watch(() => selectedFilterStatus.value, fetchData);
    watch(() => sortByDescription.value, fetchData);
    watch(() => sortBy.value, fetchData);
    watch(
      () => props.isReload,
      (newVal) => {
        if (newVal) {
          fetchData();
          emit("done-reload");
        }
      }
    );
    const handlePageChange = (page) => {
      paginationItem.currentPage = page;
      fetchData();
    };
    const viewHandler = (item) => {
      renderDataDetails.value = item;
      isTriggiered.value = true;
    };
    const editHandler = (item) => {
      // renderDataUpdate.value = item;
      emit("renderUpdate", true, item);
    };
    const HandlerFilter = (val) => {
      selectedFilterStatus.value = val;
    };
    const renderCompileDay = (item) => {
      let result;

      if (item.approvaltype === "Pending Documents") {
        let compileDay = item.graceperiod;
        let renderStart = item.renderstartdate;
        let renderEnd;
        let remainDays;
        let currentDate = moment();

        renderEnd = moment(renderStart).add(compileDay, "days");

        remainDays = renderEnd.diff(currentDate, "days");

        result = remainDays >= 0 ? remainDays + 1 : remainDays;
      } else {
        result = "-";
      }
      return result;
    };

    const HandlerSortDescription = (val) => {
      sortByDescription.value = val;
    };

    const HandlerSort = (val) => {
      sortBy.value = val;
    };

    return {
      fetchData,
      updatedDataArray,
      ...toRefs(paginationItem),
      totalPages,
      filterLimit,
      HandlerData,
      HandlerSearch,
      selectedPageSize,
      searchData,
      fetchDataCount,
      handlePageChange,
      viewHandler,
      renderDataDetails,
      renderDataUpdate,
      isTriggiered,
      editHandler,
      isModalUpdate,
      HandlerFilter,
      selectedFilterStatus,
      approvalTypeCountList,
      fetchGroupApprovalDataCount,
      renderCompileDay,
      sortByDescription,
      HandlerSortDescription,
      HandlerSort,
    };
  },
};
</script>
